import { Data, TransformsList } from 'cio/utils/analytics/transforms';
import { getSqlDatabaseName } from 'cio/utils/sql-import';
import { generateSource } from '../sources';

function typeSourceAndSyncTarget(data: Data) {
  return {
    'Database Type': getSqlDatabaseName(data?.model?.database?.get('type')),
    Source: generateSource(data),
    'Sync Target': data?.model?.syncTarget === 'People' ? 'People' : 'Objects',
  };
}

const Transforms: TransformsList = {
  type({ hideSyncTarget = false, ...data }) {
    return {
      'Database Type': getSqlDatabaseName(data?.model?.database?.get('type')),
      ...(!hideSyncTarget && data?.model?.syncTarget != null
        ? { 'Sync Target': data?.model?.syncTarget === 'People' ? 'People' : 'Objects' }
        : {}),
    };
  },

  typeAndStatus(data) {
    return {
      'Database Type': getSqlDatabaseName(data?.model?.database?.get('type')),
      'Sync Status': data?.model?.active ? 'Active' : 'Paused',
    };
  },

  selectDatabaseStarted({ frequency, interval, syncToSegment, syncTarget }) {
    return {
      Frequency: frequency,
      Interval: interval,
      'Sync To Segment': syncToSegment,
      'Sync Target': syncTarget === 'People' ? 'People' : 'Objects',
    };
  },

  addDatabaseStarted(data) {
    return typeSourceAndSyncTarget(data);
  },

  addDatabaseFailed(data) {
    return {
      ...typeSourceAndSyncTarget(data),
      'Error Message': data?.errorMessage,
    };
  },

  deleteDatabaseStarted(data) {
    return typeSourceAndSyncTarget(data);
  },

  editDatabaseStarted(data) {
    return typeSourceAndSyncTarget(data);
  },

  editDatabaseFailed(data) {
    return {
      ...typeSourceAndSyncTarget(data),
      'Error Message': data?.errorMessage,
    };
  },

  runQueryStarted(data) {
    return {
      ...typeSourceAndSyncTarget(data),
      'Is Relationship Query': data?.model?.relationship != null,
    };
  },

  runQueryFailed(data) {
    return {
      ...typeSourceAndSyncTarget(data),
      'Error Message': data?.errorMessage,
      'Is Relationship Query': data?.model?.relationship != null,
    };
  },

  reviewImport(data) {
    return {
      query: data?.model?.query,
      'Sync Target': data?.model?.syncTarget === 'People' ? 'People' : 'Objects',
      ...(data.model?.relationship?.query != null ? { 'Relationship Query': data.model.relationship.query } : {}),
    };
  },
};

export default Transforms;
